import React from 'react';
import { Popconfirm } from 'antd';

import { Button } from '../Button';
import { useUIText } from '../../i18n';

export interface ConfirmButtonProps {
    onConfirm: () => void;
    label?: React.ReactNode;
    icon?: React.ReactNode;
    type?: 'primary' | 'default' | 'text' | 'link';
    danger?: boolean;
    disabled?: boolean;
    confirmTitle?: React.ReactNode;
    confirmDescription?: React.ReactNode;
}

/**
 * Tier-1 presentational primitive. A themed kit `Button` that asks for
 * confirmation via antd `Popconfirm` before firing `onConfirm` — encapsulates
 * the repo's destructive-action convention. No domain/store imports.
 */
export function ConfirmButton({
    onConfirm,
    label,
    icon,
    type = 'default',
    danger = false,
    disabled = false,
    confirmTitle,
    confirmDescription,
}: ConfirmButtonProps): React.ReactElement {
    const { common } = useUIText();

    return (
        <Popconfirm
            title={confirmTitle ?? common.confirm}
            description={confirmDescription ?? common.confirmDelete}
            onConfirm={onConfirm}
            okText={common.confirm}
            cancelText={common.cancel}
            okButtonProps={{ danger }}
            disabled={disabled}
        >
            <Button
                className="confirm-button"
                type={type}
                danger={danger}
                disabled={disabled}
                icon={icon}
            >
                {label}
            </Button>
        </Popconfirm>
    );
}

export default ConfirmButton;
